import { render, staticRenderFns } from "./AppAuth.vue?vue&type=template&id=745d0be2&"
import script from "./AppAuth.vue?vue&type=script&lang=ts&"
export * from "./AppAuth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports